import { auth0ApiClient } from './auth0ApiClient'

export interface UsageReportUsers {
  totalUsers: number
  usersByRole: { mentors: number; mentees: number; admins: number }
}

export interface UsageReportRelationships {
  total: number
  active: number
  ended: number
  byStatus: Record<string, number>
}

export interface UsageReportCount {
  total: number
}

export interface UsageReport {
  generatedAt: string
  cached: boolean
  partial: boolean
  unavailableServices: string[]
  users: UsageReportUsers | null
  relationships: UsageReportRelationships | null
  tasks: UsageReportCount | null
  messages: UsageReportCount | null
  meetings: UsageReportCount | null
  resources: UsageReportCount | null
}

export interface RelationshipReport {
  generatedAt: string
  cached: boolean
  partial: boolean
  unavailableServices: string[]
  byStatus: Record<string, number> | null
  averageDurationMs: number | null
}

interface UsageReportEnvelope {
  success: boolean
  data: UsageReport
}

interface RelationshipReportEnvelope {
  success: boolean
  data: RelationshipReport
}

class AdminReportService {
  private readonly baseUrl = '/admin/reports'

  async getUsageReport(): Promise<UsageReport> {
    const envelope = await auth0ApiClient.getEnvelope<UsageReportEnvelope>(`${this.baseUrl}/usage`)
    return envelope.data
  }

  async getRelationshipReport(): Promise<RelationshipReport> {
    const envelope = await auth0ApiClient.getEnvelope<RelationshipReportEnvelope>(
      `${this.baseUrl}/relationships`
    )
    return envelope.data
  }
}

export const adminReportService = new AdminReportService()
